import { CombinedAppointmentsModalAction, CombinedAppointmentsModalState } from "./modals.combinedAppointments.types";

export const combinedAppointmentsModalSetAction = (modal: Partial<CombinedAppointmentsModalState>): CombinedAppointmentsModalAction => ({ type: 'COMBINED_APPOINTMENTS_MODAL_SET', params: modal })

export const combinedAppointmentsModalCloseAction = (): CombinedAppointmentsModalAction => ({ type: 'COMBINED_APPOINTMENTS_MODAL_CLOSE' })